module.exports = __webpack_public_path__ + "static/img/solution_img3.01855410.png";